import React, { useCallback, useContext, useState } from 'react';
import { CloseSquareOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import EventFilterContext from '@totem/components/services/threats/eventFilters/EventFilterContext';
import { debounce } from '@totem/utilities/debounce';

const DEBOUNCE_TIME = 300;

const EventSearch = () => {
  const { input, setInput } = useContext(EventFilterContext);
  const [searchTerm, setSearchTerm] = useState<string>('');

  const sendEventSearch = useCallback(
    debounce(
      (newSearchTerm: string) =>
        setInput({ ...input, searchTerm: newSearchTerm }),
      DEBOUNCE_TIME,
    ),
    [],
  );

  const handleEventSearch = (newSearchTerm: string) => {
    setSearchTerm(newSearchTerm);

    sendEventSearch(newSearchTerm);
  };

  return (
    <table style={{ width: '100%' }}>
      <tbody>
        <tr>
          <td style={{ width: '300px' }}>
            <Input
              placeholder="Event Description"
              value={searchTerm}
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
                evt.target.value !== null
                  ? handleEventSearch(evt.target.value)
                  : handleEventSearch('')
              }
            />
          </td>
          <td>
            <br />
            <CloseSquareOutlined onClick={() => handleEventSearch('')} />
          </td>
          <td>&nbsp;</td>
        </tr>
      </tbody>
    </table>
  );
};

export default EventSearch;
